import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@qodo/design-system';
import { spawn } from 'utils/translations';

type UnsavedChangesDialogProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const UnsavedChangesDialog = ({
  open,
  onCancel,
  onConfirm,
}: UnsavedChangesDialogProps) => {
  const spawnDialog = spawn('dialogs.discard-changes');

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent autoFocus={false} className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-h3">{spawnDialog('title')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{spawnDialog('description')}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{spawnDialog('action.cancel')}</Button>
          </DialogClose>
          <Button variant="danger" onClick={onConfirm}>
            {spawnDialog('action.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
